"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const bit_utils_context_1 = require("@gcloud-npm/bit.utils.context");
const bit_utils_metrics_1 = require("@gcloud-npm/bit.utils.metrics");
const bit_utils_ping_cms_page_1 = __importDefault(require("@gcloud-npm/bit.utils.ping-cms-page"));
const prop_types_1 = __importDefault(require("prop-types"));
const MetaData_1 = __importDefault(require("./MetaData"));
let lastPageObserverName = '';
class Page extends react_1.Component {
    constructor(props) {
        super(props);
        this.checkFullLoadedPage = () => {
            const { projectId } = this.metricsControl;
            const queueName = 'AppController-PageLoaded';
            const observerName = `${projectId}-LOADED`;
            window.nookInfoExchange.registerAsObserver(queueName, observerName, (loadedData) => {
                window.nookInfoExchange.cleanObserver(queueName, observerName);
                this.metricsControl.loadedData = loadedData;
                this.loadedEventPage();
            });
        };
        this.checkExtraPageInfo = () => {
            const { projectId } = this.metricsControl;
            window.nookInfoExchange.registerAsObserver('AppController-ExtraPageInfo', `${projectId}-EXTRAPAGEINFO`, (extraPageInfo) => {
                this.cleanExtraPageInfoObserver();
                this.metricsControl.extraPageInfo = extraPageInfo;
                this.printEventHandler();
            });
        };
        this.checkFullPagePrint = () => {
            // interval to have printTimie
            this.fullPagePrint = setInterval(() => {
                let { fullPagePrint } = this;
                const { timing } = window.performance;
                if (fullPagePrint) {
                    const renderMs = timing.domComplete - timing.domLoading;
                    const resultTime = Math.round(renderMs / 100) / 10;
                    if (resultTime && resultTime > 0) {
                        // it means we kille interval
                        clearInterval(fullPagePrint);
                        fullPagePrint = resultTime;
                        this.metricsControl.printTime = fullPagePrint;
                        this.printEventHandler();
                    }
                }
            }, 1000);
        };
        this.buildViewData = (data) => {
            let { 'user-type': userType } = data;
            let contextUserRole = '';
            if (userType === 'Gestor') {
                userType = 'Telco';
                contextUserRole = 'gestor';
            }
            return Object.assign(Object.assign({}, data), { 'context-page-id': this.props.gaPageId, 'context-user-role': contextUserRole, 'user-type': userType });
        };
        this.pageEventsHandler = (data) => {
            // CMS-PAGE-VIEW = (COMMON PAGE INFO)
            const { view } = this.metricsControl;
            this.metricsControl.viewData = Object.assign(Object.assign({}, this.buildViewData(data)), { event: 'cms-page', 'event-type': 'view' });
            // montar el pagename solo si isBuyProcess
            const { isBuyProcess, extraPageInfo } = this.metricsControl;
            if (extraPageInfo) {
                this.metricsControl.viewData = Object.assign(Object.assign({}, this.metricsControl.viewData), extraPageInfo);
            }
            if (isBuyProcess) {
                this.metricsControl.viewData = Object.assign(Object.assign({}, this.metricsControl.viewData), { 'page-name': (0, bit_utils_metrics_1.convertPathToPageName)() });
            }
            if (document && document.location && document.location.href) {
                this.metricsControl.viewData['context-url'] = document.location.href;
            }
            // si no hemos enviado evento y tenemos los datos preparados => enviamos
            if (!view) {
                window.nookInfoExchange.sendMessage(this.metricsControl.queueName, this.metricsControl.viewData);
                this.metricsControl.view = true;
                return null;
            }
            // CMS-PAGE-UPDATE
            // only if we dont have send any event
            const { update, print, printData } = this.metricsControl;
            if (!update && print) {
                this.metricsControl.updateData = Object.assign(Object.assign({}, printData), { 'event-type': 'update' });
                window.nookInfoExchange.sendMessage(this.metricsControl.queueName, this.metricsControl.updateData);
                this.metricsControl.update = true;
                return null;
            }
            return null;
        };
        this.printEventHandler = () => {
            // CMS-PAGE-PRINTED
            const { print, viewData } = this.metricsControl;
            const { printTime, extraPageInfo, pageWithExtraInfo } = this.metricsControl;
            if (!print &&
                printTime > -1 &&
                viewData &&
                (extraPageInfo || !pageWithExtraInfo)) {
                this.metricsControl.printData = Object.assign(Object.assign(Object.assign({}, viewData), extraPageInfo), { event: 'cms-page', 'event-type': 'printed', 'full-page-print': printTime });
                window.nookInfoExchange.sendMessage(this.metricsControl.queueName, this.metricsControl.printData);
                this.metricsControl.print = true;
            }
        };
        this.loadedEventPage = () => {
            // CMS-PAGE-LOADED => TODOS LOS RECURSOS ESTAN CARGADOS
            const { loaded, print, printData } = this.metricsControl;
            if (print && !loaded) {
                this.metricsControl.loadedData = Object.assign(Object.assign({}, printData), { event: 'cms-page', 'event-type': 'loaded' });
                window.nookInfoExchange.sendMessage(this.metricsControl.queueName, this.metricsControl.loadedData);
                this.metricsControl.loaded = true;
            }
        };
        this.checkPageChanges = () => {
            (0, bit_utils_context_1.mapContextParamsToPageEvent)(lastPageObserverName, (data) => {
                this.pageEventsHandler(data);
            });
        };
        this.cleanExtraPageInfoObserver = () => {
            const { projectId } = this.props;
            const queueName = 'AppController-ExtraPageInfo';
            window.nookInfoExchange.cleanObserver(queueName, `${projectId}-EXTRAPAGEINFO`);
            window.nookInfoExchange.cleanQueue(queueName);
        };
        this.resetObservers = () => {
            if (lastPageObserverName &&
                window &&
                window.nookInfoExchange &&
                window.nookInfoExchange.cleanObserver) {
                window.nookInfoExchange.cleanObserver('Context-Page-Params', lastPageObserverName);
                this.cleanExtraPageInfoObserver();
            }
        };
        this.componentDidMount = () => {
            const { context } = this.props;
            const { pageWithExtraInfo } = this.metricsControl;
            // 1) Say hello to cms
            const ping = new bit_utils_ping_cms_page_1.default({ context });
            ping.sendPingCmsPage();
            // 2) notify virtual navigation we have changed
            window.nookInfoExchange.sendMessage('SPA-Location', {});
            // 3) handling de pageView because depends on SEO and pageInfo
            this.checkPageChanges();
            // 4) interval checking to know when page is printed
            this.checkFullPagePrint();
            // 5) Aditional info on buyProcess
            if (pageWithExtraInfo) {
                this.checkExtraPageInfo();
            }
            // 6) Check front flat to notify when page is absolutely loaded including services
            this.checkFullLoadedPage();
        };
        this.shouldComponentUpdate = () => false;
        const { pageId, seoCustomValue, projectId, isBuyProcess, match, context, } = props;
        /* We need to know if this page is about a specific product */
        let pageWithExtraInfo = false;
        if ((props.match &&
            props.match.params &&
            Object.keys(props.match.params).length > 0) ||
            isBuyProcess) {
            pageWithExtraInfo = true;
        }
        try {
            this.resetObservers();
        }
        catch (error) {
            console.log({ error });
        }
        lastPageObserverName = `App-${projectId}-Page-Observer`;
        this.metricsControl = {
            /* información */
            projectId,
            pageId,
            segment: context.pageSegment,
            match,
            // soy un proceso de compra
            isBuyProcess,
            // necesito evento para pintar printed
            pageWithExtraInfo,
            extraPageInfo: null,
            seoCustomValue,
            /* Eventos */
            view: false, // page view
            viewData: null,
            print: false,
            printData: null,
            loaded: false,
            loadedData: null,
            update: false,
            queueName: 'Metrics',
            fullPagePrint: null,
        };
    }
    render() {
        const { projectId, pageWithExtraInfo, seoCustomValue, pageId, segment, match, } = this.metricsControl;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(MetaData_1.default, { segment: segment, pageWithExtraInfo: pageWithExtraInfo, match: match, projectId: projectId, pageId: pageId, seoCustomValue: seoCustomValue, onFinish: (seoInfo) => {
                    this.metricsControl.seoInfo = seoInfo;
                } })));
    }
}
Page.propTypes = {
    pageId: prop_types_1.default.string.isRequired,
    isBuyProcess: prop_types_1.default.bool,
};
Page.defaultProps = {
    isBuyProcess: false,
};
exports.default = Page;
//# sourceMappingURL=index.js.map